// extracted by mini-css-extract-plugin
export default {"originInputGroupContainer":"style_originInputGroupContainer__v8cr9","addInstruction":"style_addInstruction__z+ZP-","inputField":"style_inputField__yKo8P"};